module.exports = __webpack_public_path__ + "static/media/img103_R.74a9fc38.jpg";